// src/pages/Solarization.js

import React from 'react';
import TopBar from '../components/TopBar';

const Solarization = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="solarization" userClaims={userClaims} />
      
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-6">
          <div className="p-6 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-yellow-100">
              <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
              </svg>
            </div>
            <h3 className="text-lg font-semibold mb-2">Solarization Module</h3>
            <p className="text-gray-600 mb-4">Use of solar-powered solutions for vaccine supply chain.</p>
            <p className="text-gray-500">This module is under development. Coming soon.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solarization; 